// extracted by mini-css-extract-plugin
export var brand = "_34-7";
export var compact = "_34-5";
export var extraSmall = "_34-a";
export var icon = "_34-0";
export var large = "_34-3";
export var light = "_34-1";
export var medium = "_34-4";
export var outline = "_34-9";
export var primaryDark = "_34-8";
export var primaryLight = "_34-6";
export var primaryModern = "_34-b";
export var success = "_34-2";